import { call, put, select, takeEvery } from 'redux-saga/effects';
import { addNotification as notify } from 'reapop';

import { createSagas, bootSagas } from 'helpers/hotelModuleHelper';
import { actions, actionTypes } from '../actions/offerte';
import { selectors, DEFAULT_STATE } from '../reducers/offerte';
import api from '../apis/offerte';
import hotelApi from 'modules/hotel/apis/hotel';
import { normalizeHotelSiteUrl, purgeOffertaCache } from 'apis/waoTheme';
import { purgeOffertaImages } from 'apis/barret';

function updateFailErrorCreator(error) {
    if (error && error.response && error.response.status === 401) {
        return {
            message:
                "Non disponi dei privilegi necessari per aggiornare l'offerta"
        };
    }

    return {
        message: 'Si è verificato un errore inaspettato'
    };
}

const sagas = createSagas(
    'offerte',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        updateFailErrorCreator
    }
);

sagas.purgeSitoHotel = function* purgeSitoHotel(offerta) {
    if (!offerta.hasSito) {
        // Logs per purge cache offerte sito hotel (disattivati)
        // console.warn('[WAO purge] sito hotel SKIP: hasSito falsy', {
        //     idOfferta: offerta.idOfferta,
        //     hasSito: offerta.hasSito
        // });
        return;
    }

    const response = yield call(hotelApi.fetch, offerta.idHotel);
    const web = response && response.data ? response.data.web : '';
    const siteUrl = normalizeHotelSiteUrl(web);
    if (!siteUrl) {
        // Logs per purge cache offerte sito hotel (disattivati)
        // console.warn('[WAO purge] sito hotel SKIP: web vuoto/non valido', {
        //     idHotel: offerta.idHotel,
        //     web
        // });
        return;
    }

    // Logs per purge cache offerte sito hotel (disattivati)
    // console.log('%c[WAO purge] sito hotel → chiamo tema', 'color:#06c', {
    //     idOfferta: offerta.idOfferta,
    //     idHotel: offerta.idHotel,
    //     web,
    //     siteUrl
    // });

    yield call(purgeOffertaCache, siteUrl, offerta.idOfferta);

    // Logs per purge cache offerte sito hotel (disattivati)
    // console.log(
    //     '%c[WAO purge] sito hotel OK',
    //     'color:#0a7;font-weight:bold',
    //     { siteUrl, idOfferta: offerta.idOfferta }
    // );
};

sagas.purgeBarret = function* purgeBarret(offerta) {
    // Logs per purge cache offerte sito hotel (disattivati)
    // console.log('%c[WAO purge] barret → inizio', 'color:#06c', {
    //     idOfferta: offerta.idOfferta,
    //     imgList: offerta.imgList
    // });

    yield call(purgeOffertaImages, offerta.imgList);

    // Logs per purge cache offerte sito hotel (disattivati)
    // console.log(
    //     '%c[WAO purge] barret OK',
    //     'color:#0a7;font-weight:bold',
    //     { idOfferta: offerta.idOfferta }
    // );
};

sagas.purgeCache = function* purgeCache() {
    const current = yield select(selectors.currentSelector);
    const offerta = current && current.item;

    if (!offerta || !offerta.idOfferta) {
        // Logs per purge cache offerte sito hotel (disattivati)
        // console.warn('[WAO purge] SKIP: nessun current.item / idOfferta');
        return;
    }

    // Logs per purge cache offerte sito hotel (disattivati)
    // console.log(
    //     '%c========== WAO purge (dopo salvataggio offerta) ==========',
    //     'color:#06c;font-weight:bold',
    //     {
    //         idOfferta: offerta.idOfferta,
    //         idHotel: offerta.idHotel,
    //         hasSito: offerta.hasSito
    //     }
    // );

    try {
        yield call(sagas.purgeSitoHotel, offerta);
    } catch (e) {
        // Logs per purge cache offerte sito hotel (disattivati)
        // console.error('[WAO purge] sito hotel FALLITO → toast warning', e);
        yield put(
            notify({
                title: 'Attenzione!',
                message:
                    "Offerta salvata. Non è stato possibile aggiornare la cache del sito dell'hotel: le modifiche potrebbero non essere subito visibili online.",
                status: 'warning'
            })
        );
    }

    try {
        yield call(sagas.purgeBarret, offerta);
    } catch (e) {
        // Logs per purge cache offerte sito hotel (disattivati)
        // console.error('[WAO purge] barret FALLITO (silenzioso)', e);
    }
};

const defaultSagas = bootSagas(sagas, actionTypes);

export { sagas };

export default [
    ...defaultSagas,
    takeEvery(actionTypes.updateSuccess, sagas.purgeCache)
];
